

const About = {
    about: {
        title: "I live somewhere between programming and engineering.",
        description: "From an early age, I developed a fascination with building, assembling, and disassembling things. At around 12 years old, my brother introduced me to programming, which sparked my excitement. I began by writing simple programs in PascalABC, and soon after, I found another area of interest—radio electronics and robotics. For a few years, I worked with microcontrollers like Arduino and mini computers such as Raspberry Pi. During this time, I created projects ranging from motion detection systems to an autonomous car with a controller. As my passion for programming grew, I decided to focus more on honing my skills, which led me to learn Python. While I continued to improve my programming knowledge, I would occasionally switch my attention back to engineering. When I turned 16, my journey took a new turn. At 16, I moved to Canada, and during the COVID lockdown, I found myself unsure of what to do. It was then that my brother, a professional programmer, introduced me to Handmade Hero, a series of videos by Casey Muratori. This series was a game-changer for me. Watching Casey build a game engine almost entirely in raw C and explain his decision-making process in real time opened my eyes to the intricacies of programming. It inspired me to embark on creating my own game engine, which I’ve been working on for over three years. Along the way, I’ve built a small prototype game and an editor to accompany it. Though it's still a work in progress, it serves as a testament to my programming knowledge and growth. After graduating from Delview Secondary High School, I entered the job market, looking for opportunities in programming or game development. However, the reality is that breaking into the industry without formal experience or a degree is a challenge. So, I took a job at GolfBalls.ca, where the work is simple: sorting golf balls into the correct bins. While the job may be repetitive, it sparked an idea—why not automate it? This led me to start two projects: the Golf Ball Counter and the Golf Ball Sorter/Grader. I began with the Counter, and today I have an almost-working prototype. I’m continuously learning and growing, driven by my curiosity and desire to innovate. My journey in programming, engineering, and automation is far from over, and I’m excited for what lies ahead.",
        experience: [
            {
                title: "",
                company: "",
                date: "",
                description: "",
            },
        ],
        education: [
            {
                degree: "High School",
                program: "",
                school: "",
                date: "",
                about: ""
            }
        ]
    },
    contact: {
        title: "Get in touch.",
        description: "I'm always interested in meeting new people. You can shoot me an email at",
        email: "paul.solodrai@gmail.com",
        formspree: ""
    },
    home: {
        name: "Pavlo Solodrai",
        title: "Personal blog where I talk about stuff that I do.",
        description: "I'm a programmer and engineer. This blog is a place where I share my thoughts, decisions, experiences and eplain reasons for particular decisions.",
    },

    projects: {
        title: "This page is a list of all projects that I have worked or am working on.",
        description: "All projects have their related articles and links to blog posts. In each project, I explain why I decided to do it what is the goal of the project and on what stage it is now.",
    },

    spellweaver_saga: {
        title: "Spellweaver Saga",
        description: "Spellweaver Saga is a roguelike adventure where players explore islands created after a cataclysm, seeking to restore the world. Using a deep spell crafting system, everything from combat to puzzles revolves around elemental magic.",
    },

    social: {
        linkedin: "stephenahayes",
        github: "babykaban",
        x: "BabyKaban"
    },

};

export default About;
